// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__qCcnX","icon":"styles_icon__zxmQr","secondary":"styles_secondary__1aP7E","disabled":"styles_disabled__2Ftb_"};